<template>
  <b-input-group>
    <b-select
      :disabled="!canFetchData || fetching"
      :value="value"
      :state="state"
      :options="options"
      @input="$emit('input', $event)"
    >
      <template v-slot:first>
        <b-select-option
          :value="''"
          disabled
        >
          {{ options.length === 0 ? 'Refresh to display options' : 'Select ' + name }}
        </b-select-option>
      </template>
    </b-select>

    <template v-slot:append>
      <b-button
        :disabled="!canFetchData || fetching"
        @click="fetchData"
      >
        Refresh
        <b-spinner
          v-if="fetching"
          small
        />
      </b-button>
    </template>
  </b-input-group>
</template>

<script lang="ts">

import { SnowflakeConfigReponse } from '@/types'
import Vue from 'vue'
import Component from 'vue-class-component'

const props = {
  state: Boolean,
  value: {
    type: String,
    required: true,
  },
  username: {
    type: String,
    default: '',
  },
  password: {
    type: String,
    default: '',
  },
  account: {
    type: String,
    default: '',
  },
  warehouse: {
    type: String,
    default: '',
  },
}

@Component({
  watch: {
    options (newValue) {
      if (newValue.length === 1) {
        this.$emit('input', newValue[0])
      }
    },
  },
})
export default class SnowflakeDropdown extends Vue.extend({ props }) {
  response: SnowflakeConfigReponse[] = []
  fetching = false

  // generic, will be override
  name!: string

  get options () {
    return this.response.map((o: { name : string }) => o.name)
  }

  // generic, will be override
  get canFetchData () { return false }

  // generic, will be override
  fetchData () {}
}

</script>
